<template>
  <div>
    <modal v-if="isModalShow" @close="closed">
      <template slot="header">
        <h4 class="modal-title">장학 신청자 업로드</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closed"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <md-card>
        <md-card-content>
          <div class="flex-div">
            <div class="inline-flex mb10">
              <input v-focus type="file" class="hidden-input-file" id="bundleFileInput" accept=".xlsx">
              <input type="text" v-model="excelFileName">
              <button v-focus @click="onClickSearchExcel">
                <md-icon>search</md-icon>엑셀 파일 찾기
              </button>
            </div>
            <md-button class="md-success md-sm full-size-button" @click="uploadExcelFile" :disabled="!excelFile">
              <md-icon>publish</md-icon>
              엑셀 업로드
            </md-button>
          </div>
        </md-card-content>
        </md-card>
      </template>

      <template slot="footer">
        <md-button class="md-danger md-simple" @click="closed">
          Close
        </md-button>
      </template>
    </modal>
  </div>
</template>

<script>

import kuaaApi from "@/kuaa/kuaa-api";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import URL_CONST from "@/kuaa/kuaa-url-const";
import { Modal } from "@/components";
import parser from "@/kuaa/kuaa-parser";
import Swal from "sweetalert2";

export default {
  name: "ApplyExcelUploadComp",
  props: {
    isShow : {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal
  },

  created() {
  },

  computed: {
    isModalShow: function(){
      return this.isShow;
    }
  },
  data() {
    return {
      excelFile: null,
      excelFileName: null
    };
  },

  methods: {
    closed(){
      this.$emit('update:isShow', false);
    },
    handleAddress(data){
      this.$emit('returnResult', data);
    },

    onClickSearchExcel() {
      let input = document.getElementById("bundleFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.excelFileName = file.name;
        this.excelFile = file;
      };
      input.click();
    },

    uploadExcelFile() {
      this.$emit('update:isShow', false);

      parser.parseXlsApplyRequestData(this.excelFile, (res) => {

        let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
          html: "장학 신청자 정보를 업로드 하시겠습니까?",
        });

        Swal.fire(modalOptions).then(result => {
          if (result.value) {
            modalOptions = kuaaFnc.getSwalModaloptions();
            kuaaApi.sendServer(
                URL_CONST.SAVE_SCHA_APPLY_LIST,
                res,
                "post",
                response => {
                  if (response.data.success){
                    modalOptions.html = `[${response.data.data}]건 처리 되었습니다.`;
                    Swal.fire(modalOptions);
                    this.excelFileName = null;
                    this.excelFile = null;
                  } else {
                    modalOptions.html = `처리에 실패 하였습니다.`;
                    Swal.fire(modalOptions);
                  }
                }
            );
          }
        });
      });
    }
  }
}
</script>

<style lang="css" scoped>

</style>